import { Locale } from "@common/constans";
import { IViewport } from "@config/appConfig";
import { Culture } from "@core/index";
import { IAppState } from "@misc/State";
import { redirectToLogin } from "@service/Account";
import Config from "@service/Config";
import Translate from "@service/Translate";
import { FC } from "react";
import ContentLoader from "react-content-loader";
import { useSelector } from "react-redux";
import Button from "./general/form/Button";
import Icon from "./general/Icon";

interface IAvatarProps {
    onClick?: () => void;
}

const Avatar: FC<IAvatarProps> = (props) => {
    const { tr } = Translate;
    const IrLocale = Culture.getLocale(Locale.fa);
    const { dir, lang } = Culture.getLocale();
    const { small } = Config.get<IViewport>("viewport");
    const { user, showHeaderSkeleton, width } = useSelector((state: IAppState) => ({
        user: state.user,
        showHeaderSkeleton: state.showHeaderSkeleton,
        width: state.windowWidth
    }));
    const hasTransparentClass = document.getElementById('header')?.classList.contains("transparent");
    const skeletonUser = (
        <div className="skeleton-user">
            <ContentLoader
                width={width > small ? "140" : "40"}
                height="40"
                speed={1}
                backgroundColor={hasTransparentClass ? "#fff" : "#ececec"}
                foregroundColor={hasTransparentClass ? "#c6c6c6" : "#949494"}
                rtl={dir === "rtl"}
            >
                <circle cx="20" cy="20" r="20" />
                {
                    width > small ? <>
                        <rect x="50" y="7" rx="3" ry="3" width="80" height="11" />
                        <rect x="50" y="23" rx="3" ry="3" width="60" height="11" />
                    </>
                        : ""
                }
            </ContentLoader>
        </div>
    );
    const showLocalName = lang === IrLocale.lang && user.localFirstName && user.localLastName ? `${user.localFirstName} ${user.localLastName}` : `${user.firstName} ${user.lastName}`;
    const showShortenLocalName = lang === IrLocale.lang && user.localFirstName && user.localLastName ? `${user.localFirstName?.charAt(0).toUpperCase()} ${user.localLastName?.charAt(0).toUpperCase()}` :
        `${user.firstName?.charAt(0).toUpperCase()} ${user.lastName?.charAt(0).toUpperCase()}`;

    return (
        <div className="avatar" onClick={() => !showHeaderSkeleton && user.memberId && props.onClick && props.onClick()}>
            {
                showHeaderSkeleton ? skeletonUser :
                    user.memberId ?
                        <>
                            {
                                user.avatar ? <img src={`data:image/png;base64, ${user.avatar}`} alt="user-avatar" className="avatar-image" /> :
                                    <>
                                        <Icon className="avatar-icon-screen" name="icon-person" />
                                        <div className="avatar-icon-mobile">
                                            <span>{showShortenLocalName}</span>
                                        </div>
                                    </>
                            }
                            <div className="avatar-info">
                                <div className="full-name">{showLocalName}</div>
                                <div className="member-id">{user.memberId}</div>
                            </div>
                        </> :
                        width > small ?
                            <Button
                                id="loginRegisterBtn"
                                text={tr("btn_login_register")}
                                variant="outlined"
                                height="40px"
                                className="login-register-btn"
                                onClick={redirectToLogin}
                            /> :
                            <Icon
                                name="icon-person"
                                className="login-register-btn-mobile"
                                onClick={redirectToLogin}
                            />
            }

        </div>
    )
}
export default Avatar;